import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import { TypeAnimation } from 'react-type-animation';
import Aos from 'aos';
import 'aos/dist/aos.css';


const Message_P = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])
  return (
    <div>
      <Container>
        <h3 className='text-center mt-5 mb-5'>Principal's Message</h3>
        <Row className='d-flex justify-content-center'>
          <Col md={4} className='d-flex justify-content-center flex-column mb-5 bg-dark pt-3 rounded'>
            <Image fluid rounded src={require('../../Images/Principal.png')} />
            <p className='text-center fw-bold mt-2 fs-5 text-white'>Sh. Anjani Kumar Srivastava</p>
          </Col>
        </Row>
        <Row className='d-flex justify-content-center'>
          <Col md={7}>
            <div>
              <h3 data-aos='fade-right' className='text-center mt-5 mb-5'>Principal's Perception- Epitome of Learning</h3>
              <TypeAnimation
                // splitter={(str) => str.split(/(?= )/)}
                sequence={[
                  '“Education is not the filling of a pail, but the lighting of a fire.” — W.B. Yeats.At Priyanka Memorial International School, we believe that every child carries within them a unique spark of potential.Our mission is to nurture this spark into a flame of knowledge, confidence, and character.Education, to us, goes beyond textbooks—it is about shaping responsible individuals who are prepared to face the challenges of the modern world with courage and integrity.    “Success is not final, failure is not fatal: it is the courage to continue that counts.” —            Winston Churchill.            We are committed to providing a safe, inclusive, and stimulating environment where students are encouraged to explore, question, and grow. With a blend of academic excellence, co-curricular activities, and value-based education, we aim to develop well-rounded personalities who can contribute meaningfully to society.Our dedicated faculty works tirelessly to inspire young minds, instilling discipline, creativity, and a lifelong love for learning. We emphasize not only intellectual growth but also moral values, empathy, and respect for others.“Where there is vision, there is growth; where there is dedication, there is success.”As we move forward, we seek the continuous support and cooperation of parents, teachers, and students in building a strong foundation for a brighter future.Let us work together to empower our children to dream big, achieve excellence, and become responsible global citizens. With warm regards,'
                ]}
                speed={{ type: 'keyStrokeDelayInMs', value: 10 }}
                style={{ fontSize: '1em', display: 'block', minHeight: '200px' }}
                repeat={0}
                className='CPdocs'
              />
              <h5 className=' mt-5 mb-5'>Sh. Anjani Kumar Srivastava<br />
                Principal <br />Priyanka Memorial International School</h5>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Message_P
